import React from 'react'
import { IntlProvider } from 'react-intl'
import settings from '../settings'
//
// ─── IMPORT FARSI FORM VALIDATION MESSAGES FOR THE FORM VALIDATOR ───────────────
//

import fa from '../locale/fa.json'
import en from '../locale/en.json'

const { isRTL, LOCALE_IN_USE } = settings

function AppProviders({ children }) {
  return (
    <IntlProvider locale={LOCALE_IN_USE} messages={isRTL() ? fa : en}>
      {children}
    </IntlProvider>
  )
}

export default AppProviders
